export default function RemoveExtraSpaces(string) {
  return string.replace(/\s{2,}/g, " ");
}
